import Swiper from 'swiper/bundle';

export default class CirculeeIntroLayout {
	constructor() {
		this.instances = new Map();
	}

	init() {
		for (const grid of document.querySelectorAll('.intro--buhck .intro-grid')) {
			this.initSlider(grid);
		}
	}

	initSlider(grid) {
		if (this.instances.has(grid)) {
			return;
		}

		const cards = Array.from(grid.children);

		if (cards.length < 2) {
			return;
		}

		const wrapper = document.createElement('div');
		const controls = document.createElement('div');
		const previousButton = this.createButton(
			'intro-slider-navigation intro-slider-navigation--previous',
			'Vorherige Karte',
			'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>',
		);
		const pagination = document.createElement('div');
		const nextButton = this.createButton(
			'intro-slider-navigation intro-slider-navigation--next',
			'Nächste Karte',
			'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>',
		);

		wrapper.className = 'swiper-wrapper';
		controls.className = 'intro-slider-controls';
		pagination.className = 'intro-slider-pagination swiper-pagination';

		for (const card of cards) {
			card.classList.add('swiper-slide');
			wrapper.appendChild(card);
		}

		controls.append(previousButton, pagination, nextButton);
		grid.replaceChildren(wrapper, controls);
		grid.classList.add('swiper');

		const swiper = new Swiper(grid, {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 24,
			grabCursor: true,
			watchOverflow: true,
			breakpoints: {
				768: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
				992: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
			},
			pagination: {
				el: pagination,
				clickable: true,
			},
		});

		const updateNavigation = () => {
			previousButton.disabled = swiper.isBeginning;
			nextButton.disabled = swiper.isEnd;
			controls.hidden = swiper.isLocked;
		};

		previousButton.addEventListener('click', () => swiper.slidePrev());
		nextButton.addEventListener('click', () => swiper.slideNext());
		swiper.on('slideChange', updateNavigation);
		swiper.on('resize', updateNavigation);
		swiper.on('lock', updateNavigation);
		swiper.on('unlock', updateNavigation);
		updateNavigation();

		this.instances.set(grid, {
			cards,
			swiper,
		});
	}

	createButton(className, label, icon) {
		const button = document.createElement('button');
		button.className = className;
		button.type = 'button';
		button.setAttribute('aria-label', label);
		button.innerHTML = icon;
		return button;
	}
}
